import RegisterTradingModal from 'features/securities/AuthModal/RegisterTradingModal';

import ModalPostLimit from 'global/StreamCompose/Modal/ModalPostLimit';
import LinkError from 'global/LinkError';
import useModalStore, { ModalNames } from '../stores/useGlobalStreamError';

export default function StreamErrorModalManager() {
  const modal = useModalStore((s) => s.activeModal);
  const setModal = useModalStore((s) => s.openModal);
  const closeModal = useModalStore((s) => s.closeModal);
  const title = useModalStore((s) => s.title);
  const type = useModalStore((s) => s.type);

  if (!modal) {
    return null;
  }

  return (
    <>
      <LinkError
        visible={modal === ModalNames.COMPOSE_ERROR_LINK}
        onCancel={closeModal}
        onSubmit={() => {
          closeModal();
          setModal(ModalNames.SECURITIES_REGISTER);
        }}
        title="Tidak Dapat Post dengan Link"
        description="Untuk melindungi komunitas kami, kamu perlu membuka akun Stockbit Sekuritas agar menjadi pengguna terverifikasi sebelum dapat membuat postingan dengan tautan."
      />

      <RegisterTradingModal
        visible={modal === ModalNames.SECURITIES_REGISTER}
        onClose={closeModal}
      />

      <ModalPostLimit
        type={type}
        onCancel={closeModal}
        onSubmit={() => {
          setModal(ModalNames.SECURITIES_REGISTER);
        }}
        visible={modal === ModalNames.STREAM_POST_LIMIT}
        title={title}
      />
    </>
  );
}
